<template>
<div class="img-player">
  <div class="img-wrapper">
    <img :src="value" class="data-img" />
  </div>

  <div class="play-ctrl-bar">
    <button class="play-ctrl-btn" @click="onPlayBtnClick">
      <i :class="isPlaying ? 'el-icon-video-pause' : 'el-icon-video-play'" />
    </button>

    <div class="play-progress">
      <el-slider v-model="imgIndex" :min="0" :max="imgInfos.length - 1" :show-tooltip="false" />
    </div>

    <div class="play-config-wrapper">
      <label>每张图片播放间隔</label>
      <el-input v-model="seconds" type="number" :disabled="isPlaying" size="mini" style="width:150px;">
        <template #append>秒</template>
      </el-input>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'ImgPlayer',
  props: {
    value: {},
    imgInfos: {
      required: true,
      type: Array
    }
  },
  data: () => ({
    isPlaying: false,
    seconds: 0.1
  }),
  computed: {
    imgIndex: {
      get () {
        const {value} = this
        return this.imgInfos.findIndex(imgInfo => imgInfo.value === value)
      },
      set (index) {
        if (index === -1) {
          return
        }

        this.$emit('input', this.imgInfos[index].value)
      }
    }
  },
  methods: {
    clearPlayTimer () {
      clearTimeout(this.playerTimer)
    },
    enablePlayTimer () {
      this.clearPlayTimer()

      this.playerTimer = setTimeout(() => {
        this.imgIndex += 1

        setTimeout(() => {
          if (this.imgIndex < (this.imgInfos.length - 1)) {
            this.enablePlayTimer()
          } else {
            this.isPlaying = false
          }
        }, 0)
      }, this.seconds * 1000)
    },
    onPlayBtnClick () {
      this.isPlaying = !this.isPlaying

      if (this.isPlaying) {
        const {imgInfos} = this
        const {length} = imgInfos

        if (length > 1) {
          if (this.imgIndex === (length - 1)) {
            this.imgIndex = 0
          }

          this.enablePlayTimer()
        }
      } else {
        this.clearPlayTimer()
      }
    }
  },
  beforeDestroy () {
    this.clearPlayTimer()
  },
  watch: {
    imgInfos () {
      this.clearPlayTimer()
      this.isPlaying = false
    }
  }
}
</script>

<style lang="scss">
.img-player {
  display: grid;
  grid-template-rows: auto max-content;

  > * {
    min: {
      width: 0;
      height: 0;
    };
  }

  > .img-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .data-img {
    max-width: 75%;
    max-height: 75%;
  }

  > .play-ctrl-bar {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    padding: 10px 0;
    white-space: nowrap;
  }

  .play-ctrl-btn {
    font-size: 28px;
    width: 28px;
    height: 28px;
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    color: #409eff;
    background-color: transparent;
    cursor: pointer;

    &:hover {
      color: #66b1ff;
    }

    &:active {
      color: #3a8ee6;
    }
  }

  .play-progress {
    width: 200px;
  }

  .play-config-wrapper {
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ImgPlayer/index.vue